import * as S from "./FloatingButton.style";

interface FloatingButtonProps {
  nav?: boolean;
  icon: React.ReactNode;
  onClick?: any;
}

export const FloatingButton = ({ icon, nav, onClick }: FloatingButtonProps) => {
  return (
    <S.FloatingButton $nav={nav} onClick={onClick}>
      {icon}
    </S.FloatingButton>
  );
};
